<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

    page: {
        title: 'Новый сервер',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader, Multiselect },

    data() {
        return {
            title: 'Новый сервер',
            items: [],
            server_uuid: '',
            name: '',
            code: '',
            trackBy: 'id',

            type: null,
            initType: [],            
            type_options: [
                {id: 'pbx', name: 'pbx'},                
                {id: 'calls-logic-demons', name: 'calls-logic-demons'},
                {id: 'mq', name: 'mq'},
                {id: 'kaldi', name: 'kaldi'}
            ],

            ip: null,
            cloud_id: null,
            priority: 0,

            status: null,
            initStatus: [],            
            status_options: [
                {id: 'active',     name: 'Активен'},
                {id: 'on',         name: 'Включён'},
                {id: 'stop',       name: 'Остановка'},
                {id: 'off',        name: 'Остановлен'},
                {id: 'accident',   name: 'Авария'},
                {id: 'prevention', name: 'Профилактика'},
            ]
        }
    },

    watch: {
        initType: {
            immediate: true,
            handler(values) {
                this.type = this.type_options.filter(x => values.includes(x[this.trackBy]));
                this.type = this.type[0];
            }
        },
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
    },

    computed: {
        server_item(){
            return this.$store.getters['servers/GET_SERVERS_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
    },

    async mounted() {
        this.server_uuid = this.$route.params.server_uuid ? this.$route.params.server_uuid : '';
        if(this.server_uuid !== ''){

            this.title = 'Настройка сервера';
            document.title = appConfig.title + ' - ' + 'Настройка сервера';

            let data_send = {
                'uuid' : this.server_uuid
            }

            await this.$store.dispatch('servers/FETCH_SERVERS_ITEM', data_send);

            this.name       = this.server_item.name     ? this.server_item.name     : '';
            this.ip         = this.server_item.ip       ? this.server_item.ip       : '';
            this.type       = this.server_item.type     ? this.server_item.type     : '';
            this.priority   = this.server_item.priority ? this.server_item.priority : '';
            this.cloud_id   = this.server_item.cloud_id ? this.server_item.cloud_id : '';
            this.status     = this.server_item.status   ? this.server_item.status   : '';
            this.initType   = [ this.type ];            
            this.initStatus = [ this.status ];
        }
    },

    methods: {

        async saveItem(){

            let data_send = {
                'name'     : this.name,
                'ip'       : this.ip,
                'cloud_id' : this.cloud_id,
                'priority' : this.priority,
                'type'     : this.type   && this.type.id   ? this.type.id   : null,
                'status'   : this.status && this.status.id ? this.status.id : null,
            };

            // console.log(data_send);            

            let result = '';

            if(this.server_uuid === ''){
                result = await this.$store.dispatch('servers/FETCH_SERVERS_CREATE', data_send);
            } else {
                data_send.uuid = this.server_uuid;
                result = await this.$store.dispatch('servers/FETCH_SERVERS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Servers'});
            }
        }
    },
}

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Название сервера"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="Укажите название сервера"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="IP"
                                        label-for="ip"
                                    >
                                        <b-form-input
                                            id="ip"
                                            v-model="ip"
                                            placeholder="Укажите IP адрес"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Cloud ID"
                                        label-for="cloud_id"
                                    >
                                        <b-form-input
                                            id="cloud_id"
                                            v-model="cloud_id"
                                            placeholder="Укажите ID сервера в облаке"
                                        ></b-form-input>
                                    </b-form-group>
                                    
                                    <b-form-group
                                        label="Приоритет запуска"
                                        label-for="priority"
                                    >
                                        <b-form-input
                                            id="priority"
                                            v-model="priority"
                                            placeholder="Укажите приоритет"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Тип сервера"
                                        label-for="type"
                                    >
                                        <multiselect
                                            id="type"
                                            :track-by="trackBy"
                                            v-model="type"
                                            :options="type_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            :track-by="trackBy"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
